import { useAppSelector } from "@/redux/rootReducer"
import { selectAuthUser } from "@/redux/reducers/auth.reducer"
import { isStaff } from "@/utils/type-guards"


const useIsPds = () => {
  const authUser = useAppSelector(selectAuthUser)
  return isStaff(authUser) && authUser?.status === 'PDS'
}

export default useIsPds

